var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.37152,12.67633Q20.4,12.33732,20.4,12q0-.33719-.0285-.67639l2.08875-1.20593-3.6-6.23536L16.76935,5.08948A8.39236,8.39236,0,0,0,15.6,4.416V2H8.4V4.416a8.39582,8.39582,0,0,0-1.16937.67346L5.13971,3.88232l-3.6,6.23536,2.08875,1.20593Q3.6,11.66263,3.6,12q0,.33709.0285.67633L1.53973,13.88226l3.6,6.23542,2.09094-1.20716A8.39545,8.39545,0,0,0,8.4,19.58392V22h7.2V19.58392a8.392,8.392,0,0,0,1.16937-.6734l2.09094,1.20716,3.6-6.23542ZM18.4,12a6.39035,6.39035,0,0,1-.23809,1.71l1.56628.9043-1.6,2.7713-1.5639-.90289A6.38679,6.38679,0,0,1,13.6,18.19025V20H10.4V18.19025a6.38709,6.38709,0,0,1-2.96435-1.70752l-1.5639.90289-1.6-2.7713L5.83807,13.71a6.26015,6.26015,0,0,1,0-3.4201l-1.56628-.9043,1.6-2.7713,1.5639.90289A6.387,6.387,0,0,1,10.4,5.80975V4h3.2V5.80975a6.38669,6.38669,0,0,1,2.96435,1.70746l1.5639-.90289,1.6,2.7713-1.56628.9043A6.39046,6.39046,0,0,1,18.4,12ZM12,8a4,4,0,1,0,4,4A4.004,4.004,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2.0026,2.0026,0,0,1,12,14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.7303c4770076b92d6bbde05793a49b7f.svg";
export { ForwardRef as ReactComponent };